import React from "react";
import { Container, ButtonContainer } from "./mini-lessons-thumbnail.styles";
import VideoPlayer from "../video/video.component";
import RoundedButton from "../rounded-button/rounded-button.component";
import { useHistory } from "react-router-dom";

const MiniLessonsThumbnail = ({
	videoURL = "https://player.vimeo.com/external/794448801.m3u8?s=2677d6206deba94d81ad522f39ddc802f8a9d5ee",
	miniLessonID = "Bgd1itlvPkL4E90sUY0L",
	isHLSType = true,
}) => {
	const history = useHistory();
	return (
		<Container>
			<VideoPlayer
				srcVideo={videoURL}
				autoPlay={true}
				aspectRatio={[9.01, 16]}
				controls={false}
				transitionDuration={0}
				muted={true}
				loop={true}
				style={{
					maxWidth: "calc(32% + 25px)",
				}}
				{...{ isHLSType }}
			></VideoPlayer>
			<div>
				<div
					style={{
						fontSize: "50px",
					}}
				>
					MINI
				</div>
				<div
					style={{
						fontSize: "24px",
						marginTop: "-10px",
					}}
				>
					LESSONS
				</div>
				<div style={{ textAlign: "center", color: "gray" }}>(beta)</div>

				<ButtonContainer>
					<RoundedButton
						onClick={() => {
							history.push(`/mini-lessons/${miniLessonID}`);
						}}
					>
						WATCH
					</RoundedButton>
				</ButtonContainer>
			</div>
		</Container>
	);
};

export default MiniLessonsThumbnail;
